<template>
	<div>
		<header class="home-head">
			<nav class="container">
				<div class="row">
					<div class="col-xs-5 col-sm-3 col-md-2 col-lg-2 top-nav-container">
						<router-link
							class="btn btn-clear btn-sm"
							role="button"
							to="/"
						>
							<i class="material-icons btn-icon-lg">home</i>
						</router-link>
						<!-- Member dropdown -->
						<b-dropdown class="dropdown btn-group">
							<button
								class="btn btn-clear btn-sm dropdown-toggle"
								type="button"
								id="profile"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="true"
							>
								<i class="material-icons btn-icon-lg">person</i>
							</button>
							<template slot="dropdown" class="dropdown-menu">
								<li class="dropdown-title">{{ name }}</li>
								<li><router-link to="/profile" role="button">My profile</router-link></li>
								<li v-if="isAdmin"><router-link to="/admin" role="button">Admin</router-link></li>
								<li @click="logout"><router-link to="/login">Logout</router-link></li>
							</template>
						</b-dropdown>
					</div>
					<div class="col-xs-7 logo-container-head visible-xs">
						<router-link to="/">
							<img
								class="img-responsive logo-head"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</router-link>
					</div>

					<div class="col-xs-12 col-sm-5 col-md-6 col-lg-5">
						<div class="input-group quick-search quick-search-top top-nav-container">
							<input
								v-model="searchTerm"
								type="text"
								class="form-control"
								placeholder="Quick search"
								@keyup.enter="search"
							>
							<span class="input-group-btn">
								<b-btn class="btn-primary" @click="search">
									<i class="material-icons">search</i>
								</b-btn>
							</span>
						</div>
					</div>

					<div class="col-sm-4 col-md-4 col-lg-5 logo-container-head hidden-xs">
						<router-link to="/">
							<img
								class="img-responsive logo-head"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</router-link>
					</div>
				</div>
			</nav>
		</header>
		<div class="header-border"/>
	</div>
</template>

<style lang="less" scoped>
	.btn-primary {
		height:57px;
		width:57px;
	}
</style>

<script>
import { mapGetters } from 'vuex';
import { isNull } from 'lodash/fp';

export default {
	props: {
		name: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			searchTerm: null
		};
	},
	computed: {
		...mapGetters({ isAdmin: 'admin' })
	},
	methods: {
		logout() {
			this.$emit('logout');
		},
		search() {
			if (!isNull(this.searchTerm)) {
				this.$router.push({
					path: '/notifications',
					query: {
						searchTerm: this.searchTerm
					}
				});
			}
		}
	}
};
</script>
